import { notification } from "antd";
import { apiRequest } from "util/services";

function resolveReviewDashId(review) {
  const direct = review?.dash_id ?? review?.dashId;
  if (direct != null && direct !== "") {
    const parsed = parseInt(direct, 10);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  const dashboardId = review?.dashboard_id;
  if (
    dashboardId != null &&
    dashboardId !== "" &&
    /^\d+$/.test(String(dashboardId).trim())
  ) {
    const parsed = parseInt(dashboardId, 10);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }
  return null;
}

/**
 * Fetch dashboard highlights for drawer reviews (console ReviewsList parity).
 * Groups review ids by dashboard and merges responses keyed by date_gpid.
 */
export async function fetchDrawerReviewHighlights(
  reviews,
  { notifyOnError = true } = {},
) {
  if (!Array.isArray(reviews) || reviews.length === 0) {
    return {};
  }

  const groups = {};
  for (const review of reviews) {
    const dashId = resolveReviewDashId(review);
    const gpid = review?.date_gpid;
    if (!dashId || !gpid) continue;
    if (!groups[dashId]) groups[dashId] = [];
    groups[dashId].push(gpid);
  }

  let merged = {};
  for (const [dashboardId, reviewIds] of Object.entries(groups)) {
    const uniqueIds = [...new Set(reviewIds)];
    const result = await apiRequest(
      "dashboards/highlights",
      "POST",
      {
        review_ids: uniqueIds,
        dashboard_id: parseInt(dashboardId, 10),
      },
      true,
    );
    if (result?.success) {
      merged = { ...merged, ...result.success };
    } else if (notifyOnError) {
      notification.error({
        message: result?.error || "Unable to get reviews highlights",
      });
    }
  }

  return merged;
}
